<template>
  <div class="invite-benefit-section">
    <!-- 혜택 01 -->
    <div class="benefit-card">
      <div class="benefit-card__badge">
        <span class="typo-caption-xs-bold" style="color: var(--color-text-accent, #008DEF);">혜택01</span>
      </div>
      <div class="benefit-card__text">
        <h2 class="benefit-card__title typo-heading-xxl-bold">솔닥 컨시어지가 드리는 선물</h2>
        <p class="benefit-card__desc typo-body-m-medium">친구랑 나랑 함께 혜택을 받아 보세요!</p>
      </div>
      <img
        class="benefit-card__img"
        src="@/assets/home/img_hifive.png"
      />
      <div class="benefit-card__info">
        <div class="benefit-card__info-row">
          <img class="benefit-card__info-icon" src="@/assets/home/icn_lucky_color.png" />
          <div class="benefit-card__info-text">
            <span class="typo-body-m-bold">친구 혜택</span>
            <p class="typo-body-s-medium">솔닥 컨시어지에서 연속혈당측정기 첫 구매 시 네이버페이 3만원 경품을 드려요.</p>
          </div>
        </div>
        <div class="benefit-card__divider"></div>
        <div class="benefit-card__info-row">
          <img class="benefit-card__info-icon" src="@/assets/home/icn_lucky_color.png" />
          <div class="benefit-card__info-text">
            <span class="typo-body-m-bold">나의 혜택</span>
            <p class="typo-body-s-medium">친구가 솔닥 컨시어지에서 연속혈당측정기를 첫 구매하면 네이버페이 3만원 경품을 드려요.</p>
          </div>
        </div>
      </div>
      <!-- <div class="benefit-card__notice">
        <img class="benefit-card__notice-icon" src="@/assets/home/icn_warning_circle_color.png" />
        <p class="benefit-card__notice-text typo-body-s-medium">*단, 연속혈당측정기 제품 중 '가디언4(미니메드 780G)' 및 '가디언4(Standalone)' 제품은 이벤트 대상에서 제외됩니다.</p>
      </div> -->
    </div>

    <!-- 혜택 02 -->
    <div class="benefit-card benefit-card--gray">
      <div class="benefit-card__badge">
        <span class="typo-caption-xs-bold" style="color: var(--color-text-accent, #008DEF);">혜택02</span>
      </div>
      <div class="benefit-card__text">
        <h2 class="benefit-card__title typo-heading-xxl-bold">3만원의 혜택</h2>
        <p class="benefit-card__desc typo-body-m-medium">무제한으로 받는 방법을 알려드려요!</p>
      </div>
      <img
        class="benefit-card__img benefit-card__img--small"
        src="@/assets/home/img_naverpay.png"
      />
      <div class="benefit-card__steps">
        <div class="benefit-card__step">
          <div class="benefit-card__step-number">
            <span class="typo-caption-xxs-bold" style="color: #FFF;">1</span>
          </div>
          <span class="typo-body-s-medium">솔닥 컨시어지가 처음인 친구에게 링크를 공유해 보세요.</span>
        </div>
        <div class="benefit-card__step">
          <div class="benefit-card__step-number">
            <span class="typo-caption-xxs-bold" style="color: #FFF;">2</span>
          </div>
          <span class="typo-body-s-medium">자주 이용하는 커뮤니티나 개인 SNS에 내 초대 코드를 공유하세요.</span>
        </div>
        <div class="benefit-card__step">
          <div class="benefit-card__step-number">
            <span class="typo-caption-xxs-bold" style="color: #FFF;">3</span>
          </div>
          <span class="typo-body-s-medium">추천이 성공할 때마다 혜택이 계속 쌓여요.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InviteBenefitSection',
}
</script>

<style scoped>
.invite-benefit-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  position: relative;
  z-index: 0;
}

/* 혜택 카드 */
.benefit-card {
  display: flex;
  padding: 64px 16px 32px 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  background: #FFF;
}

/* 혜택 뱃지 */
.benefit-card__badge {
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--color-bg-blue, #EFF9FF);
}

/* 타이틀 */
.benefit-card__title {
  margin: 0;
  text-align: center;
  color: var(--color-text-main, #191F28);
}

/* 타이틀 + 설명 묶음 (gap 영향 없이 간격 0) */
.benefit-card__text {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* 설명 */
.benefit-card__desc {
  margin: 0;
}

/* 하이파이브 이미지 */
.benefit-card__img {
  width: 150px;
  height: 150px;
  margin: 28px auto 12px auto;
  display: block;
  object-fit: contain;
}

/* 혜택 정보 영역 */
.benefit-card__info {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}

.benefit-card__info-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.benefit-card__info-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.benefit-card__info-text {
  display: flex;
  flex-direction: column;
}

.benefit-card__info-text p {
  margin: 0;
}

/* 구분선 */
.benefit-card__divider {
  height: 1px;
  background: var(--color-divider-200, #E5E8EB);
  margin: 16px 0;
}

/* 안내 문구 */
.benefit-card__notice {
  display: flex;
  padding: 16px;
  margin-top: 16px;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 12px;
  background: var(--Color-Gray-100, #F2F4F6);
  box-sizing: border-box;
}

.benefit-card__notice-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.benefit-card__notice-text {
  margin: 0;
  flex: 1;
  color: var(--Color-Text-strong, #4E5968);
}

/* 혜택 02 - 회색 배경 */
.benefit-card--gray {
  padding: 32px 16px;
  background: var(--color-bg-gray, #F2F4F6);
}

.benefit-card__img--small {
  width: 130px;
  height: 130px;
}

/* 스텝 텍스트 박스 */
.benefit-card__steps {
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 12px;
  background: var(--color-wb-white, #FFF);
  box-sizing: border-box;
  margin-top: 26px;
}

.benefit-card__step {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}

.benefit-card__step-number {
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 50%;
  background: #6B7684;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/InviteBenefitSection.vue